module.exports = __webpack_public_path__ + "img/traindefut.12f5f9ed.jpg";